const PROFESSIONAL_LICENSE_LIMIT_MESSAGE = 'Limite de profissionais contratados atingido. Não há licenças disponíveis para cadastrar novos profissionais. Você pode inativar profissionais que não estão mais em uso ou fazer upgrade do pacote contratado.'

export function getProfessionalLicenseLimitMessage(licenseSummary) {
  if (!licenseSummary || licenseSummary.disponiveis === null || licenseSummary.disponiveis === undefined) {
    return ''
  }

  return Number(licenseSummary.disponiveis) <= 0
    ? PROFESSIONAL_LICENSE_LIMIT_MESSAGE
    : ''
}
